import { useEffect, useState } from "react";
import { useImageStore } from "entity-store/image-store/use-image-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { useSizePresets } from "PosterEditor/model/size-presets/size-preset";
import { aspectFitSize } from "PosterEditor/utils/rect-utils";
import { PosterProject } from "PosterEditor/model/poster-project";
import { Size } from "PosterEditor/model/poster-types";

interface UseProjectThumbnailProps {
  template?: ProjectTemplate;
  project?: PosterProject;
  //Desired size - will be aspect-fit to this size,
  //and actual size will be returned.
  size: Size;
}
export const useProjectThumbnail = (props: UseProjectThumbnailProps) => {
  const [snapshot, setSnapshot] = useState<string | null>(null);
  const { getImageUrl, getRenderedThumbnailImageURL } = useImageStore();
  const { fullThumbnailSizeFromProject } = useSizePresets();

  useEffect(() => {
    const template = props.template;
    const project = props.project;

    let objectURL: string | null = null;

    if (template && template.thumbnail) {
      const fetchSnapshot = async () => {
        const url = await getImageUrl(template.thumbnail, "png", true);
        objectURL = url;
        setSnapshot(url);
      };

      fetchSnapshot();

      return () => {
        if (objectURL) {
          URL.revokeObjectURL(objectURL);
        }
      };
    } else if (project) {
      const fetchSnapshot = async () => {
        const url = await getRenderedThumbnailImageURL(project.id);
        objectURL = url ?? null;
        setSnapshot(url ?? null);
      };

      fetchSnapshot();

      return () => {
        if (objectURL) {
          URL.revokeObjectURL(objectURL);
        }
      };
    }
  }, []);

  //Fallback to map style
  const styleURL = props.template?.project.mapStyle ?? props.project?.mapStyle;
  const mapStyle = styleURL?.replace(/^mapbox:\/\/styles\/jamesbkelly\//, "");
  const mapImageURL = `/pallete-components/map-thumbnails/${mapStyle}.png`;

  const image = snapshot || props.template?.thumbnail || mapImageURL;
  const project = props.project ?? props.template?.project;

  if (!project) {
    return { image: "", size: { width: 0, height: 0 } };
  }

  const size = fullThumbnailSizeFromProject(project);

  const scaled = aspectFitSize(size, {
    width: props.size.width,
    height: props.size.height,
  });

  return { image, size: scaled };
};
